/* eslint-disable sonarjs/cognitive-complexity */
import { plainToClass } from 'class-transformer';
import { paymentHttp } from './http';
import { isApiError, BasketApiErrorModel } from 'models/Errors';
import { PaymentSessionModel } from 'models/Payment';
import { errorToBasketErrorModel } from 'helpers';
import { AddressModel, DeliveryDetailsModel } from 'models';

export class PaymentRepository {
    public async createPaymentSession(basketCode: string, amount: number, userId: string, email: string, customer: DeliveryDetailsModel, channel: string, redirectUrl: string): Promise<PaymentSessionModel> {
        try {
            const initialPaymentData = {
                basketCode,
                pointOfSale: channel,
                amount,
                language: navigator.language,
                customer: {
                    customerId: userId,
                    firstName: customer.firstName,
                    lastName: customer.surname,
                    billingAddress: this.createAddressRequestModel(customer.billingAddress!),
                    deliveryAddress: this.createAddressRequestModel(customer.deliveryAddress!),
                    phoneNumber: customer.phone,
                    email
                },
                // looks like it's not used for card payment, but still required by Adyen api
                redirectUrl
            };

            const response = await paymentHttp.post('create-payment-session', initialPaymentData);

            return plainToClass(PaymentSessionModel, response.data);
        } catch (error) {
            const errorSource = 'payment.repository:createPaymentSession';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }

    private createAddressRequestModel(address: AddressModel): any {
        return {
            city: address.town,
            country: 'GB',
            houseNumberOrName: address.number || address.building || '',
            street: address.street,
            postcode: address.postcode!.code
        };
    }
}

export const payment = new PaymentRepository();